import { useState, useRef, useEffect } from "react";
import { EventDataContext } from "../EventDataContext";
import { useContext } from "react";
import axios from "axios";
import {
  MdCheckBox,
  MdTextFields,
  MdEdit,
} from "react-icons/md";
import FileUploadComponent from "../fileUpload/FileUploadComponent";
import { FaRegCheckCircle } from "react-icons/fa";
import { BsSend } from "react-icons/bs";
import "../../styling/QuestionnaireTabBusinessCss.css";
import DeleteQuestionModal from "../modals/DeleteQuestionModal";

import businessPhoto from "../../images/BoothBloom_Banner_Business.jpg";
import weddingPhoto from "../../images/BoothBloom_Banner_Wedding.jpg";
import birthdayPhoto from "../../images/BoothBloom_Banner_Birthday.jpg";
import otherPhoto from "../../images/BoothBloom_Banner_Other.jpg";

const QuestionnaireTab = ({ brandingColours }) => {
  const { EventData, setEventData } = useContext(EventDataContext);
  const [questions, setQuestions] = useState(EventData.questionnaire || []);
  const [isEdit, setIsEdit] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [questionToDelete, setQuestionToDelete] = useState(null);

  let coverPic = otherPhoto;
  if (EventData.eventType === "corporate") {
    coverPic = businessPhoto;
  } else if (EventData.eventType === "birthday") {
    coverPic = birthdayPhoto;
  } else if (EventData.eventType === "wedding") {
    coverPic = weddingPhoto;
  }

  const handleSend = async () => {
    const updatedQuestions = questions.map(q => ({
      ...q,
      isSentToBusiness: true,
    }));  

    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/client/update-questionnaire`,
        { eventId: EventData._id, questions: updatedQuestions },
        { withCredentials: true }
      );
      alert("Sent successfully!");
    } catch (error) {
      console.error('Error updating questionnaire:', error.response?.data || error.message);
    }
  };

  const handleTextAnswerChange = (index, value) => {
    const updatedQuestions = [...questions];
    updatedQuestions[index].answer = value;
    setQuestions(updatedQuestions);
  };

  const handleEditSave = async () => {
    setIsEdit(!isEdit);
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/client/update-questionnaire`,
        { eventId: EventData._id, questions },
        { withCredentials: true }
      );
    } catch (error) {
      console.error('Error updating questionnaire:', error.response?.data || error.message);
    }
  };

  const handleCheckboxChange = (questionIndex, option) => {
    const updatedQuestions = [...questions];
    const currentAnswers = updatedQuestions[questionIndex].answer || [];
    const optionIndex = currentAnswers.indexOf(option);
  
    if (optionIndex !== -1) {
      updatedQuestions[questionIndex].answer = currentAnswers.filter((ans) => ans !== option);
    } else {
      updatedQuestions[questionIndex].answer = [...currentAnswers, option];
    }
    setQuestions(updatedQuestions);
  };
  
  return (
    <div style={{ width: "100%", position: "relative" }} className="client-questionnaire-container">
      <DeleteQuestionModal
        isModalOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        deleteQuestion={() => {}} 
      />
      {/* Questionnaire Banner Section */}
      <div style={{ position: 'relative', width: '100%', height: '224px', overflow: 'hidden', backgroundColor: '#000' }}>
  {/* 1. The Base Image */}
  <img
    src={coverPic}
    alt="cover"
    style={{ 
      width: "100%", 
      height: "100%", 
      objectFit: "cover",
      objectPosition: "top" 
    }}
  />

  {/* 2. The Blur Overlay */}
  <div style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backdropFilter: 'blur(8px)', // Adjust the blur strength here
    WebkitBackdropFilter: 'blur(8px)',
    // This mask makes the center transparent (clear) and the sides opaque (blurred)
    maskImage: 'radial-gradient(circle, transparent 30%, black 80%)',
    WebkitMaskImage: 'radial-gradient(circle, transparent 30%, black 80%)',
  }} />
  
  {/* 3. The Bottom Gradient & Text Overlay */}
  <div style={{
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '100%',
    background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
    color: 'white',
    padding: '20px',
    boxSizing: 'border-box'
  }}>
    <h1 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold' }}>
      Your Questionnaire
    </h1>
    <p style={{ margin: '5px 0 0 0', fontSize: '14px', opacity: 0.9 }}>
      Date Booked: {new Date(EventData.eventDate).toLocaleDateString()}
    </p>
  </div>
</div>
      
      <div className="event-overview-content-container">
        {/* ADDED Padding to match Business view */}
        <h2 style={{ marginTop: "30px", color: "#000000", marginBottom: "30px", padding: '20px' }}>
          Event Info
        </h2>

        {/* Render added questions with same padding as Business tab */}
        {questions
          .filter(question => question.isSentToClient === true)
          .map((question, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "20px",
                borderBottom: "1px solid #D9D9D9",
                padding: "20px", 
                position: "relative",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <p style={{ flex: 1, color: "#080700", fontSize: "16px", padding: "5px", marginBottom: "0px" }}>
                  {question.text || "Question text..."}
                </p>
              </div>

              {question.type === "text" && (
                <input
                  type="text"
                  value={question.answer || ""}
                  onChange={(e) => handleTextAnswerChange(index, e.target.value)}
                  placeholder="Enter your answer..."
                  style={{
                    marginTop: "10px",
                    border: "none",
                    padding: "5px",
                    fontSize: "14px",
                    color: "#7A7A7A",
                    background: 'transparent'
                  }}
                />
              )}

              {question.type === "checkbox" && (
                <div style={{ marginTop: "15px" }}>
                  {question.options.map((option, optionIndex) => (
                    <div key={optionIndex} style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
                      <input
                        type="checkbox"
                        style={{ width: "18px", height: "18px", marginRight: "10px" }}
                        checked={question.answer?.includes(option)}
                        onChange={() => handleCheckboxChange(index, option)}
                      />
                      <span style={{ color: "#625C73", fontSize: "15px" }}>{option}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}

        {/* Same Padding wrapper for the Logo section */}
        <div style={{ padding: '20px' }}>
          <p style={{ color: "#000000", marginBottom: "10px" }}>
            Do you have any logos or graphics you want to include?
          </p>
          <FileUploadComponent brandingColours={brandingColours} user="client" eventId={EventData._id} />
        </div>
      </div>

      {/* Button Container - Logic handles the Desktop Right/Mobile Center switch */}
      <div className="questionnaire-actions-container">
        <button 
          style={{ 
            height: "35px", 
            fontSize: "15px", 
            color: brandingColours?.primaryColor || "#2A1980", 
            background: brandingColours?.secondaryColor || "#FFFFFF", 
            border: "1px solid #D9D9D9", 
            cursor: "pointer",
            borderRadius: '5px' 
          }} 
          onClick={handleEditSave}
        >
          {!isEdit ? <MdEdit /> : <FaRegCheckCircle />} {isEdit ? "Save" : "Edit"}
        </button>
        <button 
          style={{ 
            height: "35px", 
            fontSize: "15px", 
            background: brandingColours?.primaryColor || "#2A1980", 
            color: brandingColours?.secondaryColor || "#FFFFFF",
            cursor: "pointer",
            border: "none",
            borderRadius: '5px'
          }} 
          onClick={handleSend}
        >
          <BsSend /> Send
        </button>
      </div>
    </div>
  );
};

export default QuestionnaireTab;